import { createFileRoute } from '@tanstack/react-router'

import { Breadcrumbs } from '@/components/layout/breadcrumbs.tsx'
import { LoadingSpinner } from '@/components/spinner/loading-spinner.tsx'
import { useGetAttribute } from '@/features/attributes/hooks/use-get-attribute.ts'
import { Attribute } from '@/features/attributes/types.ts'
import { AttributeForm } from '@/routes/_authenticated/settings/attributes/-components/form.tsx'

export const Route = createFileRoute(
  '/_authenticated/settings/attributes/edit/$attributeId'
)({
  component: AttributeEdit,
})

function AttributeEdit() {
  const { attributeId } = Route.useParams()

  const getAttributeQuery = useGetAttribute({ attributeId })
  const attribute = getAttributeQuery.data?.success
    ? getAttributeQuery.data?.data
    : null

  const handleSubmitted = () => getAttributeQuery.refetch()

  return (
    <>
      <Breadcrumbs
        items={[
          { name: 'Impostazioni' },
          {
            name: 'Attributi',
            to: `/settings/attributes?tab=attributes`,
          },
          {
            name: attribute?.name || attributeId,
          },
        ]}
      />

      {getAttributeQuery.isPending && (
        <div className="py-20">
          <LoadingSpinner />
        </div>
      )}

      {!getAttributeQuery.isPending && (
        <AttributeForm
          attributeId={attributeId}
          attribute={attribute as Attribute}
          onSubmitted={handleSubmitted}
        />
      )}
    </>
  )
}
